const isDev = process.env.NODE_ENV === "development";

export const logger = {
  debug: (...args) => { if (isDev) console.log("[DEBUG]", ...args); },
  info:  (...args) => { if (isDev) console.info("[INFO]", ...args); },
  warn:  (...args) => console.warn("[WARN]", ...args),
  error: (...args) => console.error("[ERROR]", ...args),
};
